import { lazyLoad } from '../utils/lazy';
export var ECarCondition;
(function (ECarCondition) {
    ECarCondition["New"] = "new";
    ECarCondition["Used"] = "used";
})(ECarCondition || (ECarCondition = {}));
export const getECarConditionList = lazyLoad(() => Object.values(ECarCondition));
export var EHomeStatus;
(function (EHomeStatus) {
    EHomeStatus["Renter"] = "rent";
    EHomeStatus["Owner"] = "own";
    EHomeStatus["OwnWithMortgage"] = "ownWithMortgage";
    EHomeStatus["WithRelative"] = "withParents";
    EHomeStatus["OwnMobileHome"] = "ownMobileHome";
    EHomeStatus["ReserveHousing"] = "reserveHousing";
    EHomeStatus["Other"] = "other";
})(EHomeStatus || (EHomeStatus = {}));
export const getEHomeStatusList = lazyLoad(() => Object.values(EHomeStatus));
export var ECountry;
(function (ECountry) {
    ECountry["Canada"] = "Canada";
})(ECountry || (ECountry = {}));
export var ETasksStatus;
(function (ETasksStatus) {
    ETasksStatus["Completed"] = "completed";
    ETasksStatus["Cancelled"] = "cancelled";
    ETasksStatus["ToDo"] = "todo";
})(ETasksStatus || (ETasksStatus = {}));
export const getETasksStatusList = lazyLoad(() => Object.values(ETasksStatus));
export var EFinancingCompany;
(function (EFinancingCompany) {
    EFinancingCompany["IFinance"] = "IFinance";
    EFinancingCompany["Iceberg"] = "Iceberg";
})(EFinancingCompany || (EFinancingCompany = {}));
export const getEFinancingCompanyList = lazyLoad(() => Object.values(EFinancingCompany));
export var EIFinanceTeam;
(function (EIFinanceTeam) {
    EIFinanceTeam["IFinance"] = "iFinance";
    EIFinanceTeam["Medicard"] = "medicard";
})(EIFinanceTeam || (EIFinanceTeam = {}));
export const getEIFinanceTeamList = lazyLoad(() => Object.values(EIFinanceTeam));
export var EDocumentStatus;
(function (EDocumentStatus) {
    EDocumentStatus["AwaitingDocument"] = "awaitingDocument";
    EDocumentStatus["AwaitingScan"] = "awaitingScan";
    EDocumentStatus["AwaitingApproval"] = "awaitingApproval";
    EDocumentStatus["Incomplete"] = "incomplete";
    EDocumentStatus["Deleted"] = "deleted";
    EDocumentStatus["Refused"] = "refused";
    EDocumentStatus["Approved"] = "approved";
})(EDocumentStatus || (EDocumentStatus = {}));
export const getEDocumentStatusSelectableList = lazyLoad(() => Object.values(EDocumentStatus).filter((item) => item !== EDocumentStatus.AwaitingDocument &&
    item !== EDocumentStatus.AwaitingScan &&
    item !== EDocumentStatus.Deleted));
export var ERequiredFrom;
(function (ERequiredFrom) {
    ERequiredFrom["Customer"] = "customer";
    ERequiredFrom["ServiceProvider"] = "serviceProvider";
    ERequiredFrom["CreditAgent"] = "creditAgent";
})(ERequiredFrom || (ERequiredFrom = {}));
export const getERequiredFromList = lazyLoad(() => Object.values(ERequiredFrom));
export var EDocumentPageStatus;
(function (EDocumentPageStatus) {
    EDocumentPageStatus["New"] = "new";
    EDocumentPageStatus["Reviewed"] = "reviewed";
    EDocumentPageStatus["Deleted"] = "deleted";
})(EDocumentPageStatus || (EDocumentPageStatus = {}));
export const getEDocumentPageStatusList = lazyLoad(() => Object.values(EDocumentPageStatus));
export var EApplicantType;
(function (EApplicantType) {
    EApplicantType["Applicant"] = "applicant";
    EApplicantType["CoApplicant"] = "coApplicant";
})(EApplicantType || (EApplicantType = {}));
export const getEApplicantTypeList = lazyLoad(() => Object.values(EApplicantType));
export var ETaskType;
(function (ETaskType) {
    ETaskType[ETaskType["RegisterToRDPRM"] = 0] = "RegisterToRDPRM";
    ETaskType[ETaskType["VerifyEmployment"] = 3] = "VerifyEmployment";
    ETaskType[ETaskType["VerifyDocument"] = 4] = "VerifyDocument";
    ETaskType[ETaskType["OtherTask"] = 5] = "OtherTask";
    ETaskType[ETaskType["VerifyMultipleEquifaxFiles"] = 6] = "VerifyMultipleEquifaxFiles";
    ETaskType[ETaskType["VerifyDateOfBirth"] = 7] = "VerifyDateOfBirth";
    ETaskType[ETaskType["VerifySin"] = 8] = "VerifySin";
    ETaskType[ETaskType["ReviewCreditFile"] = 9] = "ReviewCreditFile";
    ETaskType[ETaskType["ReviewWorksheet"] = 10] = "ReviewWorksheet";
    ETaskType[ETaskType["AnalyzeCredit"] = 11] = "AnalyzeCredit";
    ETaskType[ETaskType["VerifyBankruptcyHistory"] = 12] = "VerifyBankruptcyHistory";
    ETaskType[ETaskType["ConfirmOtherIncome"] = 13] = "ConfirmOtherIncome";
    ETaskType[ETaskType["VerifyStolenOrLostIdentity"] = 14] = "VerifyStolenOrLostIdentity";
    ETaskType[ETaskType["VerifyAddressMisuse"] = 15] = "VerifyAddressMisuse";
    ETaskType[ETaskType["VerifyFraudAlert"] = 16] = "VerifyFraudAlert";
    ETaskType[ETaskType["ValidateClientIdentity"] = 20] = "ValidateClientIdentity";
    ETaskType[ETaskType["VerifyCar"] = 21] = "VerifyCar";
    ETaskType[ETaskType["VerifyCity"] = 22] = "VerifyCity";
    ETaskType[ETaskType["ConfirmJobIncome"] = 23] = "ConfirmJobIncome";
    ETaskType[ETaskType["ConfirmAllIncomes"] = 24] = "ConfirmAllIncomes";
    ETaskType[ETaskType["VerifyWorkPermit"] = 25] = "VerifyWorkPermit";
    ETaskType[ETaskType["DetermineIfRefinancing"] = 26] = "DetermineIfRefinancing";
    ETaskType[ETaskType["RemindIdentityVerification"] = 27] = "RemindIdentityVerification";
    ETaskType[ETaskType["ConfirmActivationDateWithClient"] = 28] = "ConfirmActivationDateWithClient";
    ETaskType[ETaskType["ConfirmDetailsWithServiceProvider"] = 29] = "ConfirmDetailsWithServiceProvider";
    ETaskType[ETaskType["VerifyAccountHolderName"] = 30] = "VerifyAccountHolderName";
    ETaskType[ETaskType["InformClientGrantedAmountLowerThanRequested"] = 31] = "InformClientGrantedAmountLowerThanRequested";
    ETaskType[ETaskType["ValidateMerchant"] = 32] = "ValidateMerchant";
    ETaskType[ETaskType["CreateLoan"] = 33] = "CreateLoan";
    ETaskType[ETaskType["ContactSupportForInvestigation"] = 34] = "ContactSupportForInvestigation";
    ETaskType[ETaskType["ContactCoApplicantForAuthorization"] = 35] = "ContactCoApplicantForAuthorization";
    ETaskType[ETaskType["CompleteWorksheet"] = 36] = "CompleteWorksheet";
    ETaskType[ETaskType["VerifyWhyCvtSignatureWasDeclined"] = 37] = "VerifyWhyCvtSignatureWasDeclined";
    ETaskType[ETaskType["ContactClientToFinalizeApplication"] = 38] = "ContactClientToFinalizeApplication";
    ETaskType[ETaskType["FlinksIncomeApprovalFollowUp"] = 39] = "FlinksIncomeApprovalFollowUp";
    ETaskType[ETaskType["ValidateVoidCheque"] = 40] = "ValidateVoidCheque";
    ETaskType[ETaskType["ContactClientFollowingCancellation"] = 41] = "ContactClientFollowingCancellation";
    ETaskType[ETaskType["CreateWorksheet"] = 42] = "CreateWorksheet";
    ETaskType[ETaskType["ApproveWorksheet"] = 43] = "ApproveWorksheet";
    ETaskType[ETaskType["MissingDocument"] = 44] = "MissingDocument";
    ETaskType[ETaskType["VerifyBankStatements"] = 45] = "VerifyBankStatements";
    ETaskType[ETaskType["VerifyAddress"] = 46] = "VerifyAddress";
    ETaskType[ETaskType["FillBankAccountInformation"] = 47] = "FillBankAccountInformation";
})(ETaskType || (ETaskType = {}));
export const getETaskTypeList = lazyLoad(() => Object.values(ETaskType).filter((v) => typeof v === 'number'));
export var EDocumentType;
(function (EDocumentType) {
    EDocumentType[EDocumentType["AlimonyCourtJudgment"] = 0] = "AlimonyCourtJudgment";
    EDocumentType[EDocumentType["BandCouncilCard"] = 2] = "BandCouncilCard";
    EDocumentType[EDocumentType["BankruptcyTrusteeForm"] = 3] = "BankruptcyTrusteeForm";
    EDocumentType[EDocumentType["Bill134FormAndCreditBureau"] = 4] = "Bill134FormAndCreditBureau";
    EDocumentType[EDocumentType["BorrowerAutoInsuranceProofMentioningIceberg"] = 5] = "BorrowerAutoInsuranceProofMentioningIceberg";
    EDocumentType[EDocumentType["CarfaxLessThanMonthsAndLessThanAmount"] = 6] = "CarfaxLessThanMonthsAndLessThanAmount";
    EDocumentType[EDocumentType["CompletedAndSignedCreditApplication"] = 7] = "CompletedAndSignedCreditApplication";
    EDocumentType[EDocumentType["ContractForOtherInsuranceProductsFinanced"] = 8] = "ContractForOtherInsuranceProductsFinanced";
    EDocumentType[EDocumentType["DealerRecognitionProgramAppendix"] = 9] = "DealerRecognitionProgramAppendix";
    EDocumentType[EDocumentType["DealerResponsibilityLetter"] = 10] = "DealerResponsibilityLetter";
    EDocumentType[EDocumentType["DebtRatioAppendix"] = 11] = "DebtRatioAppendix";
    EDocumentType[EDocumentType["ElectronicSignatureAudit"] = 12] = "ElectronicSignatureAudit";
    EDocumentType[EDocumentType["EmployerForm"] = 13] = "EmployerForm";
    EDocumentType[EDocumentType["LetterOfEmployment"] = 14] = "LetterOfEmployment";
    EDocumentType[EDocumentType["ExtendedWarrantyContract"] = 15] = "ExtendedWarrantyContract";
    EDocumentType[EDocumentType["IcebergContract"] = 16] = "IcebergContract";
    EDocumentType[EDocumentType["LastPayStubJob"] = 17] = "LastPayStubJob";
    EDocumentType[EDocumentType["LastPayStubsJobTwo"] = 18] = "LastPayStubsJobTwo";
    EDocumentType[EDocumentType["LienReleaseFinancedVehicleOne"] = 19] = "LienReleaseFinancedVehicleOne";
    EDocumentType[EDocumentType["LienReleaseFinancedVehicleTwo"] = 20] = "LienReleaseFinancedVehicleTwo";
    EDocumentType[EDocumentType["MaternityLeaveBenefit"] = 21] = "MaternityLeaveBenefit";
    EDocumentType[EDocumentType["Note"] = 22] = "Note";
    EDocumentType[EDocumentType["ProofOfResidence"] = 24] = "ProofOfResidence";
    EDocumentType[EDocumentType["ProofOfBenefits"] = 25] = "ProofOfBenefits";
    EDocumentType[EDocumentType["ProofOfInsolvancyCompletion"] = 27] = "ProofOfInsolvancyCompletion";
    EDocumentType[EDocumentType["ProofOfRelease"] = 28] = "ProofOfRelease";
    EDocumentType[EDocumentType["ProofOfSourceOfFunds"] = 29] = "ProofOfSourceOfFunds";
    EDocumentType[EDocumentType["ProofOfVehicleRegistration"] = 30] = "ProofOfVehicleRegistration";
    EDocumentType[EDocumentType["References"] = 31] = "References";
    EDocumentType[EDocumentType["SecondIdWithPhoto"] = 33] = "SecondIdWithPhoto";
    EDocumentType[EDocumentType["SignedWindowSticker"] = 34] = "SignedWindowSticker";
    EDocumentType[EDocumentType["SinCardOrOfficialDocumentWithSin"] = 35] = "SinCardOrOfficialDocumentWithSin";
    EDocumentType[EDocumentType["SixMonthsPersonalBankStatements"] = 36] = "SixMonthsPersonalBankStatements";
    EDocumentType[EDocumentType["T4"] = 37] = "T4";
    EDocumentType[EDocumentType["T4E"] = 38] = "T4E";
    EDocumentType[EDocumentType["ThreeMonthsPersonalBankStatements"] = 39] = "ThreeMonthsPersonalBankStatements";
    EDocumentType[EDocumentType["Transit"] = 40] = "Transit";
    EDocumentType[EDocumentType["ValidDriverLicense"] = 41] = "ValidDriverLicense";
    EDocumentType[EDocumentType["VehiclePurchaseContract"] = 42] = "VehiclePurchaseContract";
    EDocumentType[EDocumentType["VehicleValueEvaluation"] = 43] = "VehicleValueEvaluation";
    EDocumentType[EDocumentType["VoidCheque"] = 44] = "VoidCheque";
    EDocumentType[EDocumentType["WorkPermit"] = 45] = "WorkPermit";
    EDocumentType[EDocumentType["Other"] = 46] = "Other";
    EDocumentType[EDocumentType["SignedCVT"] = 47] = "SignedCVT";
    EDocumentType[EDocumentType["LessThanThreeMonthsPersonalBankStatements"] = 48] = "LessThanThreeMonthsPersonalBankStatements";
    EDocumentType[EDocumentType["AuditCVT"] = 49] = "AuditCVT";
    EDocumentType[EDocumentType["AuthorizationForm"] = 50] = "AuthorizationForm";
    EDocumentType[EDocumentType["PreAuthorizedDebitForm"] = 51] = "PreAuthorizedDebitForm";
    EDocumentType[EDocumentType["ClinicInvoice"] = 52] = "ClinicInvoice";
    EDocumentType[EDocumentType["ChildTaxBenefitStatement"] = 53] = "ChildTaxBenefitStatement";
    EDocumentType[EDocumentType["EmploymentInsuranceStatement"] = 54] = "EmploymentInsuranceStatement";
    EDocumentType[EDocumentType["EmploymentContract"] = 55] = "EmploymentContract";
    EDocumentType[EDocumentType["ExtraPaymentAuthorization"] = 56] = "ExtraPaymentAuthorization";
    EDocumentType[EDocumentType["InvoiceForPersonalService"] = 57] = "InvoiceForPersonalService";
    EDocumentType[EDocumentType["NoticeOfAssessment"] = 58] = "NoticeOfAssessment";
    EDocumentType[EDocumentType["ProofOfIncome"] = 59] = "ProofOfIncome";
    EDocumentType[EDocumentType["ProofOfPayment"] = 60] = "ProofOfPayment";
    EDocumentType[EDocumentType["RentalAgreement"] = 61] = "RentalAgreement";
    EDocumentType[EDocumentType["RecordOfEmployment"] = 62] = "RecordOfEmployment";
    EDocumentType[EDocumentType["T1"] = 63] = "T1";
    EDocumentType[EDocumentType["T5"] = 64] = "T5";
    EDocumentType[EDocumentType["UtilityBill"] = 65] = "UtilityBill";
    EDocumentType[EDocumentType["EquifaxOrTransUnionNotice"] = 66] = "EquifaxOrTransUnionNotice";
    EDocumentType[EDocumentType["ValidPhotoId"] = 67] = "ValidPhotoId";
    EDocumentType[EDocumentType["FamilyAllocationsProof"] = 68] = "FamilyAllocationsProof";
    EDocumentType[EDocumentType["WorkIncidentIndemnisationProof"] = 69] = "WorkIncidentIndemnisationProof";
    EDocumentType[EDocumentType["MaternityPaternityIncomeProof"] = 70] = "MaternityPaternityIncomeProof";
    EDocumentType[EDocumentType["OtherIncomeProof"] = 71] = "OtherIncomeProof";
    EDocumentType[EDocumentType["RetirementIncomeProof"] = 72] = "RetirementIncomeProof";
    EDocumentType[EDocumentType["DisabilityIncomeProof"] = 73] = "DisabilityIncomeProof";
    EDocumentType[EDocumentType["AssistanceProof"] = 74] = "AssistanceProof";
    EDocumentType[EDocumentType["EmployementInsuranceProof"] = 75] = "EmployementInsuranceProof";
    EDocumentType[EDocumentType["ThirdPartyContract"] = 76] = "ThirdPartyContract";
    EDocumentType[EDocumentType["Ppsa"] = 77] = "Ppsa";
    EDocumentType[EDocumentType["VinSearch"] = 78] = "VinSearch";
    EDocumentType[EDocumentType["TemporaryDriverLicenceRenewal"] = 79] = "TemporaryDriverLicenceRenewal";
    EDocumentType[EDocumentType["ArticlesOfIncorporation"] = 80] = "ArticlesOfIncorporation";
    EDocumentType[EDocumentType["CreditInsuranceContract"] = 81] = "CreditInsuranceContract";
    EDocumentType[EDocumentType["ReplacementOrGapInsuranceContract"] = 82] = "ReplacementOrGapInsuranceContract";
    EDocumentType[EDocumentType["VehicleFinancingContract"] = 83] = "VehicleFinancingContract";
})(EDocumentType || (EDocumentType = {}));
export const getEDocumentTypeList = lazyLoad(() => Object.values(EDocumentType).filter((v) => typeof v === 'number'));
export var ECreditApplicationStep;
(function (ECreditApplicationStep) {
    ECreditApplicationStep["Financing"] = "financing";
    ECreditApplicationStep["Credit"] = "credit";
    ECreditApplicationStep["PayOut"] = "payout";
    ECreditApplicationStep["CVT"] = "CVT";
})(ECreditApplicationStep || (ECreditApplicationStep = {}));
export const getECreditApplicationStepList = lazyLoad(() => Object.values(ECreditApplicationStep));
export var EGender;
(function (EGender) {
    EGender[EGender["Men"] = 0] = "Men";
    EGender[EGender["Woman"] = 1] = "Woman";
    EGender[EGender["Other"] = 2] = "Other";
})(EGender || (EGender = {}));
export const getEGenderList = lazyLoad(() => Object.values(EGender).filter((v) => typeof v === 'number'));
export var ELanguage;
(function (ELanguage) {
    ELanguage[ELanguage["French"] = 0] = "French";
    ELanguage[ELanguage["English"] = 1] = "English";
})(ELanguage || (ELanguage = {}));
export const getELanguageList = lazyLoad(() => Object.values(ELanguage).filter((v) => typeof v === 'number'));
export var EIndustryCode;
(function (EIndustryCode) {
    EIndustryCode["FarmImplemetDealers"] = "AF";
    EIndustryCode["TruckDealers"] = "AL";
    EIndustryCode["AutomobileDealersNew"] = "AN";
    EIndustryCode["AutomotiveParts"] = "AP";
    EIndustryCode["AutomotiveRepairBodyShops"] = "AR";
    EIndustryCode["ServiceStation"] = "AS";
    EIndustryCode["TBAStoresTireDealers"] = "AT";
    EIndustryCode["AutomobileDealersUsed"] = "AU";
    EIndustryCode["AutomobileMiscellaneous"] = "AZ";
    EIndustryCode["Finance"] = "F";
    EIndustryCode["AutoFinancing"] = "FA";
    EIndustryCode["CreditUnionsFC"] = "FC";
    EIndustryCode["CreditUnionsFD"] = "FD";
    EIndustryCode["SalesFinancing"] = "FF";
    EIndustryCode["Mortgage"] = "FM";
    EIndustryCode["PersonalLoans"] = "FP";
    EIndustryCode["SavingsLoansAssns"] = "FS";
    EIndustryCode["FinanceMiscellaneous"] = "FZ";
    EIndustryCode["Banks"] = "B";
    EIndustryCode["Clothing"] = "C";
    EIndustryCode["DepartmentVariety"] = "D";
    EIndustryCode["Groceries"] = "G";
    EIndustryCode["HomeFernishings"] = "H";
    EIndustryCode["Insurance"] = "I";
    EIndustryCode["JewelryCameras"] = "J";
    EIndustryCode["Contractors"] = "K";
    EIndustryCode["LumberBldgMaterialHardware"] = "L";
    EIndustryCode["MedicalHealth"] = "M";
    EIndustryCode["OilNationalCreditCards"] = "O";
    EIndustryCode["PersonalServices"] = "P";
    EIndustryCode["RealEstateHotelsEtc"] = "R";
    EIndustryCode["SportingGoods"] = "S";
    EIndustryCode["FarmGardenSupply"] = "T";
    EIndustryCode["UtilitiesFuel"] = "U";
    EIndustryCode["Goverment"] = "V";
    EIndustryCode["Wholesale"] = "W";
    EIndustryCode["Advertising"] = "X";
    EIndustryCode["CollectionServices"] = "Y";
    EIndustryCode["MisCellnaneous"] = "Z";
})(EIndustryCode || (EIndustryCode = {}));
export const getEIndustryCodeList = lazyLoad(() => Object.values(EIndustryCode));
export var EOtherNameCode;
(function (EOtherNameCode) {
    EOtherNameCode["AlsoKnownAs"] = "AK";
    EOtherNameCode["FormerName"] = "FN";
    EOtherNameCode["LegalNameChange"] = "L";
    EOtherNameCode["CrossReference"] = "C";
})(EOtherNameCode || (EOtherNameCode = {}));
export const getEOtherNameCodeList = lazyLoad(() => Object.values(EOtherNameCode));
export var EOtherNameSuffixCode;
(function (EOtherNameSuffixCode) {
    EOtherNameSuffixCode["Senior"] = "SR";
    EOtherNameSuffixCode["Junior"] = "JR";
    EOtherNameSuffixCode["First"] = "1";
    EOtherNameSuffixCode["Second"] = "2";
    EOtherNameSuffixCode["Third"] = "3";
    EOtherNameSuffixCode["Fourth"] = "4";
    EOtherNameSuffixCode["Fifth"] = "5";
    EOtherNameSuffixCode["Sixth"] = "6";
    EOtherNameSuffixCode["Seventh"] = "7";
    EOtherNameSuffixCode["Eight"] = "8";
    EOtherNameSuffixCode["Ninth"] = "9";
    EOtherNameSuffixCode["CombinedFiles"] = "XX";
})(EOtherNameSuffixCode || (EOtherNameSuffixCode = {}));
export const getEOtherNameSuffixCodeList = lazyLoad(() => Object.values(EOtherNameSuffixCode));
export var EFolioCode;
(function (EFolioCode) {
    EFolioCode["Installment"] = "I";
    EFolioCode["Revolving"] = "R";
    EFolioCode["Mortgage"] = "M";
    EFolioCode["OpenAccount"] = "O";
    EFolioCode["LineOfCredit"] = "C";
})(EFolioCode || (EFolioCode = {}));
export const getEFolioCodeList = lazyLoad(() => Object.values(EFolioCode));
export var EAssociationCode;
(function (EAssociationCode) {
    EAssociationCode["Individual"] = "I";
    EAssociationCode["Joint"] = "J";
    EAssociationCode["Undesignated"] = "U";
})(EAssociationCode || (EAssociationCode = {}));
export const getEAssociationCodeList = lazyLoad(() => Object.values(EAssociationCode));
export var EPaymentRateCode;
(function (EPaymentRateCode) {
    EPaymentRateCode["TooNewToRate"] = "0";
    EPaymentRateCode["PaysWithin30DaysOr1PaymentPastDue"] = "1";
    EPaymentRateCode["PaysBetween30And60DaysOr2PaymentsPastDue"] = "2";
    EPaymentRateCode["PaysBetween60And90DaysOr3PaymentsPastDue"] = "3";
    EPaymentRateCode["PaysBetween90And120DaysOr4PaymentsPastDue"] = "4";
    EPaymentRateCode["Overdue120DaysAndNotYetRated9"] = "5";
    EPaymentRateCode["RegularPaymentsUnderConsolidationOrderOrSimilar"] = "7";
    EPaymentRateCode["Repossession"] = "8";
    EPaymentRateCode["BadDebt"] = "9";
})(EPaymentRateCode || (EPaymentRateCode = {}));
export const getEPaymentRateCodeList = lazyLoad(() => Object.values(EPaymentRateCode));
export var EPaymentFrequencyCode;
(function (EPaymentFrequencyCode) {
    EPaymentFrequencyCode["Monthly"] = "01";
    EPaymentFrequencyCode["BiWeekly"] = "02";
    EPaymentFrequencyCode["Weekly"] = "03";
    EPaymentFrequencyCode["SemiMonthly"] = "04";
    EPaymentFrequencyCode["DeferredPayment"] = "05";
    EPaymentFrequencyCode["InterestPaymentOnly"] = "06";
    EPaymentFrequencyCode["BiMonthly"] = "07";
    EPaymentFrequencyCode["SinglePaymentLoan"] = "08";
    EPaymentFrequencyCode["FixedPaymentAmount"] = "09";
    EPaymentFrequencyCode["Quartely"] = "10";
    EPaymentFrequencyCode["Annually"] = "11";
    EPaymentFrequencyCode["SemiAnnually"] = "12";
    EPaymentFrequencyCode["PortionOfBalanceMayRevolve"] = "13";
})(EPaymentFrequencyCode || (EPaymentFrequencyCode = {}));
export const getEPaymentFrequencyCodeList = lazyLoad(() => Object.values(EPaymentFrequencyCode));
export var EPaymentFrequency;
(function (EPaymentFrequency) {
    EPaymentFrequency["Monthly"] = "monthly";
    EPaymentFrequency["BiWeekly"] = "biWeekly";
    EPaymentFrequency["Single"] = "single";
})(EPaymentFrequency || (EPaymentFrequency = {}));
export const getEPaymentFrequencyList = lazyLoad(() => Object.values(EPaymentFrequency));
export var EMaritalStatus;
(function (EMaritalStatus) {
    EMaritalStatus[EMaritalStatus["Single"] = 0] = "Single";
    EMaritalStatus[EMaritalStatus["Married"] = 1] = "Married";
    EMaritalStatus[EMaritalStatus["DeFactoCouple"] = 2] = "DeFactoCouple";
    EMaritalStatus[EMaritalStatus["WidowWidower"] = 3] = "WidowWidower";
    EMaritalStatus[EMaritalStatus["Undefined"] = 999] = "Undefined";
})(EMaritalStatus || (EMaritalStatus = {}));
export const getEMaritalStatusList = lazyLoad(() => Object.values(EMaritalStatus).filter((v) => typeof v === 'number'));
export var EOtherIncomeType;
(function (EOtherIncomeType) {
    EOtherIncomeType[EOtherIncomeType["FamilyAllocations"] = 1] = "FamilyAllocations";
    EOtherIncomeType[EOtherIncomeType["WorkIncidentIndemnisation"] = 3] = "WorkIncidentIndemnisation";
    EOtherIncomeType[EOtherIncomeType["MaternityPaternityIncome"] = 4] = "MaternityPaternityIncome";
    EOtherIncomeType[EOtherIncomeType["Other"] = 6] = "Other";
    EOtherIncomeType[EOtherIncomeType["RetirementIncome"] = 8] = "RetirementIncome";
    EOtherIncomeType[EOtherIncomeType["DisabilityIncome"] = 11] = "DisabilityIncome";
    EOtherIncomeType[EOtherIncomeType["IncomeAdjustmentToMatchStatements"] = 12] = "IncomeAdjustmentToMatchStatements";
    EOtherIncomeType[EOtherIncomeType["Assistance"] = 13] = "Assistance";
    EOtherIncomeType[EOtherIncomeType["EmploymentInsurance"] = 14] = "EmploymentInsurance";
})(EOtherIncomeType || (EOtherIncomeType = {}));
export const getEOtherIncomeTypeSelectableList = lazyLoad(() => Object.values(EOtherIncomeType).filter((v) => typeof v === 'number' && v !== EOtherIncomeType.IncomeAdjustmentToMatchStatements));
export var EProvince;
(function (EProvince) {
    EProvince["Quebec"] = "QC";
    EProvince["Ontario"] = "ON";
    EProvince["NovaScotia"] = "NS";
    EProvince["NewBrunswick"] = "NB";
    EProvince["PrinceEdwardIsland"] = "PE";
    EProvince["Newfoundland"] = "NL";
    EProvince["BritishColombia"] = "BC";
    EProvince["Saskatchewan"] = "SK";
    EProvince["Alberta"] = "AB";
    EProvince["Manitoba"] = "MB";
    EProvince["Yukon"] = "YT";
    EProvince["Nunavut"] = "NU";
    EProvince["NorthwestTerritories"] = "NT";
})(EProvince || (EProvince = {}));
export const getEProvinceList = lazyLoad(() => Object.values(EProvince));
export var EFinancingProgram;
(function (EFinancingProgram) {
    EFinancingProgram["Auto"] = "auto";
    EFinancingProgram["IfXpress"] = "ifxpress";
    EFinancingProgram["Products"] = "products";
    EFinancingProgram["Personal"] = "personal";
    EFinancingProgram["B2c"] = "b2c";
    EFinancingProgram["AutoRsla"] = "auto-rsla";
    EFinancingProgram["MechanicalWarranty"] = "mechwarranty";
    EFinancingProgram["CreditRsla"] = "credit-rsla";
})(EFinancingProgram || (EFinancingProgram = {}));
export const getEFinancingProgramList = lazyLoad(() => Object.values(EFinancingProgram));
export var EPlanType;
(function (EPlanType) {
    EPlanType["AutoGold"] = "autoGold";
    EPlanType["AutoSilver"] = "autoSilver";
    EPlanType["AutoBronze"] = "autoBronze";
    EPlanType["AutoGoldFS"] = "autoGoldFS";
    EPlanType["AutoBronzeFS"] = "autoBronzeFS";
    EPlanType["OneStar"] = "*";
    EPlanType["TwoStar"] = "**";
    EPlanType["ThreeStar"] = "***";
    EPlanType["FourStar"] = "****";
    EPlanType["FiveStar"] = "*****";
    EPlanType["Default"] = "default";
})(EPlanType || (EPlanType = {}));
export const getEPlanTypeList = lazyLoad(() => Object.values(EPlanType));
export var EDecision;
(function (EDecision) {
    EDecision["Pending"] = "pending";
    EDecision["Approved"] = "approved";
    EDecision["ManualRevision"] = "manual-revision";
    EDecision["Refused"] = "refused";
    EDecision["Error"] = "error";
})(EDecision || (EDecision = {}));
export const getEDecisionList = lazyLoad(() => Object.values(EDecision));
export var EWorksheetDecision;
(function (EWorksheetDecision) {
    EWorksheetDecision["Pending"] = "pending";
    EWorksheetDecision["Approved"] = "approved";
    EWorksheetDecision["Declined"] = "declined";
    EWorksheetDecision["ManualRevision"] = "manual-revision";
    EWorksheetDecision["ApprovedWithCondition"] = "approvedWithCondition";
})(EWorksheetDecision || (EWorksheetDecision = {}));
export const getEWorksheetDecisionList = lazyLoad(() => Object.values(EWorksheetDecision));
export var ECreditApplicationStatus;
(function (ECreditApplicationStatus) {
    ECreditApplicationStatus["Draft"] = "draft";
    ECreditApplicationStatus["Active"] = "active";
    ECreditApplicationStatus["Completed"] = "completed";
    ECreditApplicationStatus["Cancelled"] = "cancelled";
    ECreditApplicationStatus["Expired"] = "expired";
})(ECreditApplicationStatus || (ECreditApplicationStatus = {}));
export const getECreditApplicationStatusList = lazyLoad(() => Object.values(ECreditApplicationStatus));
export var EWorksheetStatus;
(function (EWorksheetStatus) {
    EWorksheetStatus["Draft"] = "draft";
    EWorksheetStatus["Active"] = "active";
    EWorksheetStatus["Completed"] = "completed";
})(EWorksheetStatus || (EWorksheetStatus = {}));
export const getEWorksheetStatusList = lazyLoad(() => Object.values(EWorksheetStatus));
export var EContractStatus;
(function (EContractStatus) {
    EContractStatus["Ready"] = "ready";
    EContractStatus["Sending"] = "sending";
    EContractStatus["Declined"] = "declined";
    EContractStatus["NotReady"] = "notready";
    EContractStatus["UnderReview"] = "review";
    EContractStatus["Completed"] = "completed";
})(EContractStatus || (EContractStatus = {}));
export const getEContractStatusList = lazyLoad(() => Object.values(EContractStatus));
export var ECreditApplicationRelation;
(function (ECreditApplicationRelation) {
    ECreditApplicationRelation["Parent"] = "parent";
    ECreditApplicationRelation["Child"] = "child";
    ECreditApplicationRelation["Sibling"] = "sibling";
})(ECreditApplicationRelation || (ECreditApplicationRelation = {}));
export const getECreditApplicationRelationList = lazyLoad(() => Object.values(ECreditApplicationRelation));
export var ETax;
(function (ETax) {
    ETax["GST"] = "gst";
    ETax["PST"] = "pst";
    ETax["HST"] = "hst";
    ETax["QST"] = "qst";
})(ETax || (ETax = {}));
export const getETaxList = lazyLoad(() => Object.values(ETax));
export var EBankruptcyType;
(function (EBankruptcyType) {
    EBankruptcyType["BankruptcyReleased"] = "A";
    EBankruptcyType["OngoingBankruptcy"] = "F";
    EBankruptcyType["OngoingConsumerProposal"] = "G";
    EBankruptcyType["ConsumerProposalReleased"] = "J";
    // DO NOT USE: Only for Equifax translation
    EBankruptcyType["_OngoingBankruptcyB"] = "B";
    EBankruptcyType["_OngoingBankruptcyE"] = "E";
    EBankruptcyType["_OngoingBankruptcyI"] = "I";
    EBankruptcyType["_OngoingBankruptcyV"] = "V";
})(EBankruptcyType || (EBankruptcyType = {}));
export const getEBankruptcyTypeList = lazyLoad(() => [
    EBankruptcyType.BankruptcyReleased,
    EBankruptcyType.OngoingBankruptcy,
    EBankruptcyType.OngoingConsumerProposal,
    EBankruptcyType.ConsumerProposalReleased,
]);
export var EBankStatementsRequiredFor;
(function (EBankStatementsRequiredFor) {
    EBankStatementsRequiredFor["Applicant"] = "applicant";
    EBankStatementsRequiredFor["Coapplicant"] = "coApplicant";
    EBankStatementsRequiredFor["Both"] = "both";
})(EBankStatementsRequiredFor || (EBankStatementsRequiredFor = {}));
export const getEBankStatementsRequiredForList = lazyLoad(() => Object.values(EBankStatementsRequiredFor));
export var ERelationToApplicant;
(function (ERelationToApplicant) {
    ERelationToApplicant["Spouse"] = "SP";
    ERelationToApplicant["CommonLaw"] = "CL";
    ERelationToApplicant["Employer"] = "Employer";
    ERelationToApplicant["InLaw"] = "IL";
    ERelationToApplicant["Parental"] = "PR";
    ERelationToApplicant["GrandMother"] = "GM";
    ERelationToApplicant["GrandFather"] = "GF";
    ERelationToApplicant["Brother"] = "B";
    ERelationToApplicant["Sister"] = "S";
    ERelationToApplicant["Other"] = "Other";
})(ERelationToApplicant || (ERelationToApplicant = {}));
export const getERelationToApplicantList = lazyLoad(() => Object.values(ERelationToApplicant));
export var EProgressionStatus;
(function (EProgressionStatus) {
    EProgressionStatus["Quotation"] = "QT";
    EProgressionStatus["Submitted"] = "SU";
    EProgressionStatus["AwaitingDecision"] = "AD";
    EProgressionStatus["CreditPending"] = "CP";
    EProgressionStatus["ConditionalApproval"] = "CA";
    EProgressionStatus["Approved"] = "AP";
    EProgressionStatus["Declined"] = "DE";
    EProgressionStatus["DocumentReceived"] = "DR";
    EProgressionStatus["DocumentIncomplete"] = "DI";
    EProgressionStatus["PaymentPending"] = "PP";
    EProgressionStatus["Booked"] = "BK";
    EProgressionStatus["WithDrawn"] = "WD";
})(EProgressionStatus || (EProgressionStatus = {}));
export const getEProgressionStatusList = lazyLoad(() => Object.values(EProgressionStatus));
export var EExternalStep;
(function (EExternalStep) {
    EExternalStep["BankAccount"] = "bankAccount";
})(EExternalStep || (EExternalStep = {}));
export const getEExternalStepList = lazyLoad(() => Object.values(EExternalStep));
export var EExternalStepStatus;
(function (EExternalStepStatus) {
    EExternalStepStatus["NotStarted"] = "notStarted";
    EExternalStepStatus["InProgress"] = "inProgress";
    EExternalStepStatus["AnalysisInProgress"] = "analysisInProgress";
    EExternalStepStatus["Completed"] = "completed";
})(EExternalStepStatus || (EExternalStepStatus = {}));
export const getEExternalStepStatusList = lazyLoad(() => Object.values(EExternalStepStatus));
export var EFinancingRefusalMessage;
(function (EFinancingRefusalMessage) {
    EFinancingRefusalMessage["TaskIncomplete"] = "taskIncomplete";
    EFinancingRefusalMessage["NotAllIcomeConfirmed"] = "notAllIcomeConfirmed";
    EFinancingRefusalMessage["MissingRequiredDocument"] = "missingRequiredDocument";
    EFinancingRefusalMessage["NormRefusalMessage"] = "normRefusalMessage";
    EFinancingRefusalMessage["MileAgeOver999999"] = "mileAgeOver999999";
    EFinancingRefusalMessage["CarfaxOver4999WithoutVehicleValueOrVehicleEvalutionDocument"] = "carfaxOver4999WithoutVehicleValueOrVehicleEvalutionDocument";
    EFinancingRefusalMessage["MissingVehicleEvalutionDocument"] = "missingVehicleEvalutionDocument";
    EFinancingRefusalMessage["MissingVehicleValueOrThirdPartyVehicleValue"] = "missingVehicleValueOrThirdPartyVehicleValue";
    EFinancingRefusalMessage["MissingExistingCustomerReference"] = "missingExistingCustomerReference";
    EFinancingRefusalMessage["DeliveryDateInPast"] = "deliveryDateInPast";
})(EFinancingRefusalMessage || (EFinancingRefusalMessage = {}));
export const getEFinancingRefusalMessageList = lazyLoad(() => Object.values(EFinancingRefusalMessage));
export var EPaymentPlan;
(function (EPaymentPlan) {
    EPaymentPlan["RegularDailyInterests"] = "regularInterest";
    EPaymentPlan["RegularPeriodInterests"] = "regularPeriod";
    EPaymentPlan["DeferredThreeMonths"] = "deferred3";
})(EPaymentPlan || (EPaymentPlan = {}));
export const getEPaymentPlanList = lazyLoad(() => Object.values(EPaymentPlan));
export var EPaymentMethod;
(function (EPaymentMethod) {
    EPaymentMethod["Check"] = "check";
    EPaymentMethod["BankTransfer"] = "bankTransfer";
    EPaymentMethod["DEFT"] = "DEFT";
    EPaymentMethod["Wire"] = "Wire";
})(EPaymentMethod || (EPaymentMethod = {}));
export const getEPaymentMethodList = lazyLoad(() => Object.values(EPaymentMethod));
export var EBeneficiaryType;
(function (EBeneficiaryType) {
    EBeneficiaryType[EBeneficiaryType["Applicant"] = 1] = "Applicant";
    EBeneficiaryType[EBeneficiaryType["Coapplicant"] = 2] = "Coapplicant";
    EBeneficiaryType[EBeneficiaryType["Other"] = 3] = "Other";
})(EBeneficiaryType || (EBeneficiaryType = {}));
export const getEBeneficiaryTypeList = lazyLoad(() => Object.values(EBeneficiaryType).filter((v) => typeof v === 'number'));
export var ELoanPurpose;
(function (ELoanPurpose) {
    ELoanPurpose["Veterinary"] = "veterinary";
    ELoanPurpose["Medical"] = "medical";
    ELoanPurpose["Aesthetics"] = "aesthetics";
    ELoanPurpose["Dentistry"] = "dentistry";
    ELoanPurpose["GoodsAndServices"] = "goodsAndServices";
    ELoanPurpose["HomeSolutions"] = "homeSolutions";
})(ELoanPurpose || (ELoanPurpose = {}));
export const getELoanPurposeList = lazyLoad(() => Object.values(ELoanPurpose).filter((v) => typeof v === 'string'));
export var EElectronicSignatureStatus;
(function (EElectronicSignatureStatus) {
    EElectronicSignatureStatus["Pending"] = "pending";
    EElectronicSignatureStatus["CreateContract"] = "createContract";
    EElectronicSignatureStatus["StartSignatureProject"] = "startSignatureProject";
    EElectronicSignatureStatus["AwaitingSignature"] = "awaitingSignature";
    EElectronicSignatureStatus["CancelSignatureProject"] = "cancelSignatureProject";
    EElectronicSignatureStatus["Completed"] = "completed";
    EElectronicSignatureStatus["Cancel"] = "cancel";
})(EElectronicSignatureStatus || (EElectronicSignatureStatus = {}));
export const getEElectronicSignatureStatusList = lazyLoad(() => Object.values(EElectronicSignatureStatus));
export var EApplicantRefusalReason;
(function (EApplicantRefusalReason) {
    EApplicantRefusalReason["ApplicantMustHaveCreditReport"] = "ApplicantMustHaveCreditReport";
    EApplicantRefusalReason["CoapplicantMustHaveCreditReport"] = "CoapplicantMustHaveCreditReport";
    EApplicantRefusalReason["IceScoreTooLow"] = "IceScoreTooLow";
})(EApplicantRefusalReason || (EApplicantRefusalReason = {}));
export const getEApplicantRefusalReasonList = lazyLoad(() => Object.values(EApplicantRefusalReason));
export var ESourceSystem;
(function (ESourceSystem) {
    ESourceSystem["Alis"] = "alis";
    ESourceSystem["Monolith"] = "monolith";
})(ESourceSystem || (ESourceSystem = {}));
export const getESourceSystemList = lazyLoad(() => Object.values(ESourceSystem));
export var EContinueFinancingDisableReason;
(function (EContinueFinancingDisableReason) {
    EContinueFinancingDisableReason["MaximumAvalaibleAmountIsTooLow"] = "maximumAvalaibleAmountIsTooLow";
    EContinueFinancingDisableReason["CreatedOnIsExpired"] = "createdOnIsExpired";
    EContinueFinancingDisableReason["WorksheetIsNotApproved"] = "worksheetIsNotApproved";
    EContinueFinancingDisableReason["CantRefinanceUntilDone"] = "refinancingInProgress";
})(EContinueFinancingDisableReason || (EContinueFinancingDisableReason = {}));
export const getEContinueFinancingDisableReasonList = lazyLoad(() => Object.values(EContinueFinancingDisableReason));
export var EOriginSystemId;
(function (EOriginSystemId) {
    EOriginSystemId["Backoffice"] = "backoffice";
    EOriginSystemId["MerchantDashboard"] = "merchdb";
    EOriginSystemId["Subscription"] = "ifinancesub";
    EOriginSystemId["B2c"] = "b2csub";
    EOriginSystemId["Autologiq"] = "autologiq";
})(EOriginSystemId || (EOriginSystemId = {}));
export const getEOriginSystemIdList = lazyLoad(() => Object.values(EOriginSystemId));
export var ECreateLoanStatus;
(function (ECreateLoanStatus) {
    ECreateLoanStatus["Running"] = "Running";
    ECreateLoanStatus["Completed"] = "Completed";
    ECreateLoanStatus["Failed"] = "Failed";
    ECreateLoanStatus["Canceled"] = "Canceled";
    ECreateLoanStatus["Pending"] = "Pending";
    ECreateLoanStatus["NotCreated"] = "NotCreated";
})(ECreateLoanStatus || (ECreateLoanStatus = {}));
export const getECreateLoanStatusList = lazyLoad(() => Object.values(ECreateLoanStatus));
export var EProductsInsurance;
(function (EProductsInsurance) {
    EProductsInsurance["CreditInsurance"] = "creditInsurance";
    EProductsInsurance["ReplacementOrGapInsurance"] = "replacementOrGapInsurance";
    EProductsInsurance["ExtendedWarranty"] = "extendedWarranty";
})(EProductsInsurance || (EProductsInsurance = {}));
export const getEProductsInsuranceList = lazyLoad(() => Object.values(EProductsInsurance));
export var EJobType;
(function (EJobType) {
    EJobType[EJobType["FullTime"] = 0] = "FullTime";
    EJobType[EJobType["PartTime"] = 1] = "PartTime";
    EJobType[EJobType["Seasonal"] = 3] = "Seasonal";
    EJobType[EJobType["SelfEmployed"] = 5] = "SelfEmployed";
    EJobType[EJobType["Unemployed"] = 6] = "Unemployed";
})(EJobType || (EJobType = {}));
export const getEJobTypeList = lazyLoad(() => Object.values(EJobType).filter((v) => typeof v === 'number'));
export var EMerchantNotificationCode;
(function (EMerchantNotificationCode) {
    EMerchantNotificationCode["HardHitMissing"] = "HardHitMissing";
    EMerchantNotificationCode["IncomeVerificationMissing"] = "IncomeVerificationMissing";
    EMerchantNotificationCode["ContractMissing"] = "ContractMissing";
})(EMerchantNotificationCode || (EMerchantNotificationCode = {}));
export const getEMerchantNotificationCodeList = lazyLoad(() => Object.values(EMerchantNotificationCode));
export var EConsignoSignatureStatus;
(function (EConsignoSignatureStatus) {
    EConsignoSignatureStatus["Completed"] = "COMPLETED";
    EConsignoSignatureStatus["Declined"] = "DECLINED";
})(EConsignoSignatureStatus || (EConsignoSignatureStatus = {}));
export const getEConsignoSignatureStatusList = lazyLoad(() => Object.values(EConsignoSignatureStatus));
export var EPromoCodeStatus;
(function (EPromoCodeStatus) {
    EPromoCodeStatus["Invalid"] = "invalid";
    EPromoCodeStatus["Expired"] = "expired";
    EPromoCodeStatus["Valid"] = "valid";
})(EPromoCodeStatus || (EPromoCodeStatus = {}));
export var EFlinksEventSteps;
(function (EFlinksEventSteps) {
    EFlinksEventSteps["SESSION_STORAGE_BLOCKED"] = "SESSION_STORAGE_BLOCKED";
    EFlinksEventSteps["SESSION_STORAGE_BLOCKED_RETRY"] = "SESSION_STORAGE_BLOCKED_RETRY";
    EFlinksEventSteps["INSTITUTION_SELECTED"] = "INSTITUTION_SELECTED";
    EFlinksEventSteps["COMPONENT_LOAD_CREDENTIAL"] = "COMPONENT_LOAD_CREDENTIAL";
    EFlinksEventSteps["COMPONENT_ACCEPT_CONSENT"] = "COMPONENT_ACCEPT_CONSENT";
    EFlinksEventSteps["COMPONENT_DENY_CONSENT"] = "COMPONENT_DENY_CONSENT";
    EFlinksEventSteps["COMPONENT_ACCEPT_TERMS"] = "COMPONENT_ACCEPT_TERMS";
    EFlinksEventSteps["COMPONENT_DENY_TERMS"] = "COMPONENT_DENY_TERMS";
    EFlinksEventSteps["COMPONENT_CLICK_TERMS_URL"] = "COMPONENT_CLICK_TERMS_URL";
    EFlinksEventSteps["SUBMIT_CREDENTIAL"] = "SUBMIT_CREDENTIAL";
    EFlinksEventSteps["RETRY_COUNT"] = "RETRY_COUNT";
    EFlinksEventSteps["MAXIMUM_RETRY_REACHED"] = "MAXIMUM_RETRY_REACHED";
    EFlinksEventSteps["QUESTION_NOT_FOUND"] = "QUESTION_NOT_FOUND";
    EFlinksEventSteps["COMPONENT_LOAD_MFA"] = "COMPONENT_LOAD_MFA";
    EFlinksEventSteps["SUBMIT_MFA"] = "SUBMIT_MFA";
    EFlinksEventSteps["SUBMIT_GET_MFA_QUESTIONS"] = "SUBMIT_GET_MFA_QUESTIONS";
    EFlinksEventSteps["ENHANCED_MFA_HAS_QUESTIONS"] = "ENHANCED_MFA_HAS_QUESTIONS";
    EFlinksEventSteps["ENHANCED_MFA_NO_QUESTIONS"] = "ENHANCED_MFA_NO_QUESTIONS";
    EFlinksEventSteps["SUBMIT_ANSWER_MFA_QUESTIONS"] = "SUBMIT_ANSWER_MFA_QUESTIONS";
    EFlinksEventSteps["ENHANCED_MFA_SUCCESS"] = "ENHANCED_MFA_SUCCESS";
    EFlinksEventSteps["SKIP_ENHANCED_MFA"] = "SKIP_ENHANCED_MFA";
    EFlinksEventSteps["COMPONENT_LOAD_ACCOUNT_SELECTION"] = "COMPONENT_LOAD_ACCOUNT_SELECTION";
    EFlinksEventSteps["COMPONENT_LOAD_INSTITUTION_SELECTOR"] = "COMPONENT_LOAD_INSTITUTION_SELECTOR";
    EFlinksEventSteps["ACCOUNT_SELECTED"] = "ACCOUNT_SELECTED";
    EFlinksEventSteps["REDIRECT"] = "REDIRECT";
})(EFlinksEventSteps || (EFlinksEventSteps = {}));
export var EMerchantType;
(function (EMerchantType) {
    EMerchantType[EMerchantType["Merchant"] = 0] = "Merchant";
    EMerchantType[EMerchantType["Banner"] = 1] = "Banner";
})(EMerchantType || (EMerchantType = {}));
export var EBannerType;
(function (EBannerType) {
    EBannerType[EBannerType["User"] = 0] = "User";
    EBannerType[EBannerType["Merchant"] = 1] = "Merchant";
})(EBannerType || (EBannerType = {}));
